import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VueAMap from 'vue-amap'; //注意不要和 AMap原始名称覆盖

var amapManager = new VueAMap.AMapManager();
import { getAction } from '@/api/manage'; // 站点选择

import siteSelect from "../com/siteTree"; // 运维分析

import maintenanceTrend from '@/components/env-bigData/maintenanceTrend'; // 工单分析

import workOrder from '@/components/env-bigData/workOrder'; // 预警分析

import warningAnalysis from '@/components/env-bigData/warningAnalysis'; // 设备仪表统计

import deviceAnalysis from '@/components/env-bigData/deviceAnalysis'; // 巡检分析

import inspection from '@/components/env-bigData/inspection'; // 药物分析

import faultAnalysis from '@/components/env-bigData/faultAnalysis'; // 运维考评

import maintenanceEvaluation from '@/components/env-bigData/maintenanceEvaluation'; //边框组件

import border from '@/components/border/borderType';
import { getHistogramInfo, querySewageWarn, queryAttendanceUserLast, queryAttendanceSiteLast, queryAreaInfo, queryPipeSystem, queryManholeCover } from '@/api/api';
export default {
  data: function data() {
    return {
      standardList: [],
      borderWidth: 0,
      borderHeight: 0,
      borderWidth2: 0,
      borderHeight2: 0,
      mapBorderWidth: 0,
      mapBorderHeight: 0,
      waterWidth: '',
      waterHeight: '',
      maintenanceWidth: '',
      maintenanceHeight: '',
      workWidth: '',
      workHeight: '',
      inspectionWidth: '',
      inspectionHeight: '',
      medicineWidth: '',
      medicineHeight: '',
      warningWidth: '',
      warningHeight: '',
      analysisWidth: '',
      analysisHeight: '',
      mapData: [],
      maintenanceType: '1',
      workType: 2,
      warningType: 2,
      inspectionType: 2,
      faultType: 2,
      warningIndexFlag: 1,
      radioStatu: true,
      radioIndex: '',
      defaultValues: 0,
      showChart: true,
      peopleList: [],
      amapManager: amapManager,
      mapStyle: 'amap://styles/darkblue',
      //设置地图样式
      center: [118.047928, 24.613341],
      zoom: 12,
      plugin: [{
        pName: 'MapType',
        defaultType: 0,
        showRoad: false,
        showButton: false,
        showTraffic: false,
        events: {
          init: function init(o) {}
        }
      }],
      markerList: [],
      onlineNum: 0,
      siteId: '',
      idType: '',
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      },
      Inter: null,
      district: null,
      citys: [],
      pipeList: [],
      wellList: [],
      wellImg: require('@/assets/others/well.png'),
      pipeOffset: new AMap.Pixel(-20, -25),
      pipeImg: require('@/assets/others/pipe.png')
    };
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.resetWidth);
    clearInterval(this.Inter);
  },
  computed: {
    classOption: function classOption() {
      return {
        step: .5,
        // 数值越大速度滚动越快
        limitMoveNum: 4,
        // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true,
        // 是否开启鼠标悬停stop
        direction: 1,
        // 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0,
        // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0,
        // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)

      };
    }
  },
  created: function created() {
    this.center = window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ? window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341];

    if (window.localStorage.getItem('areaNameList') && window.localStorage.getItem('areaNameList') != 'null' && window.localStorage.getItem('areaNameList') != 'undefined') {
      this.citys = JSON.parse(window.localStorage.getItem('areaNameList'));
    }
  },
  // mixins: [listenMapChange],
  mounted: function mounted() {
    var _this = this;

    this.standardList = [{
      title: '处理站',
      value: 3,
      icon: 'icon-yiliaofeishui',
      show: true
    }, {
      title: '泵站',
      value: 1,
      icon: 'icon-bengzhan1',
      show: true
    }, {
      title: '管网',
      value: 5,
      icon: '',
      img: this.pipeImg,
      show: true
    }];
    this.initData();
    this.Inter = setInterval(function () {
      _this.initData();

      _this.showChart = false;
      var timer = setTimeout(function () {
        _this.showChart = true;
        clearTimeout(timer);
      }, 1000);
    }, 180000); //自适应

    this.$nextTick(function () {
      _this.resetWidth();
    });
    window.addEventListener('resize', this.resetWidth, false);
    this.getPipeSystem();
    this.getManholeCover();
  },
  components: {
    siteSelect: siteSelect,
    maintenanceTrend: maintenanceTrend,
    workOrder: workOrder,
    deviceAnalysis: deviceAnalysis,
    warningAnalysis: warningAnalysis,
    inspection: inspection,
    faultAnalysis: faultAnalysis,
    maintenanceEvaluation: maintenanceEvaluation,
    border: border
  },
  methods: {
    selctTag: function selctTag(index, item) {
      console.log('item', item);
      console.log('markerList', this.markerList);
      console.log('pipeList', this.pipeList);
      item.show = !item.show;

      switch (item.value) {
        case 4:
          this.wellList.forEach(function (item1, index1) {
            item1.show = item.show;
          });
          break;

        case 5:
          this.pipeList.forEach(function (item1, index1) {
            item1.show = item.show;
          });
          break;

        default:
          this.markerList.forEach(function (item1, index1) {
            if (item1.siteModel.category == item.value) {
              item1.show = item.show;
            }
          });
          break;
      }
    },
    // 获取所有管网数据
    getPipeSystem: function getPipeSystem() {
      var that = this;
      queryPipeSystem({
        current: 1,
        size: 1000000
      }).then(function (res) {
        if (res.success && res.result) {
          that.pipeList = res.result.records.map(function (item) {
            var pointList = item.coordinate.split(':');
            var lines = pointList.map(function (v) {
              return v.split('-').map(function (item) {
                return item.split(',');
              });
            });
            item.lines = lines;
            item.show = true;
            return item;
          });
          console.log('that.pipeList', that.pipeList);
        }
      });
    },
    // 获取所有窨井盖数据
    getManholeCover: function getManholeCover() {
      var _this2 = this;

      var that = this;
      queryManholeCover({
        current: 1,
        size: 1000000
      }).then(function (res) {
        if (res.success && res.result) {
          that.wellList = res.result.records.map(function (item) {
            return {
              id: item.id,
              position: item.coordinate.split(','),
              content: "<img style=\"width: 30px;height: 30px;\" src=\"".concat(_this2.wellImg, "\" />"),
              events: function events() {// 点击窨井盖
              }
            };
          });
        }
      });
    },
    drawBounds: function drawBounds(type) {
      var map = amapManager.getMap();
      var areaRoot = window.localStorage.getItem('areaRoot') && window.localStorage.getItem('areaRoot') != 'null' ? window.localStorage.getItem('areaRoot').split(',') : [];
      areaRoot.forEach(function (item) {
        queryAreaInfo(item).then(function (res) {
          if (res.success) {
            var features = [];

            if (res.result.mapStructure) {
              var pointList = JSON.parse(res.result.mapStructure).features.split(':');
              features = pointList.map(function (v) {
                return v.split('-').map(function (item) {
                  return item.split(',');
                });
              });
            }

            if (features.length > 0) {
              var outer = [new AMap.LngLat(-360, 90, true), new AMap.LngLat(-360, -90, true), new AMap.LngLat(360, -90, true), new AMap.LngLat(360, 90, true)];
              var inline = features.map(function (area) {
                return area.map(function (info) {
                  return new AMap.LngLat(info[0], info[1], true);
                });
              });
              var pathArray = [outer];
              pathArray.push.apply(pathArray, inline);
              var polygon = new AMap.Polygon({
                // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
                pathL: pathArray,
                //线条颜色，使用16进制颜色代码赋值。默认值为#006600
                strokeColor: 'rgb(20,164,173)',
                strokeWeight: 4,
                //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                strokeOpacity: 0.5,
                //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
                fillColor: type == 1 ? 'rgba(0,0,0)' : 'rgba(99,99,99)',
                //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                fillOpacity: type == 1 ? 0.5 : 0.3,
                zIndex: 99999999
              });
              polygon.setPath(pathArray);
              map.add(polygon); // features.forEach(area=>{
              //   var polygon = new AMap.Polygon({
              //     // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
              //     path: area,
              //     strokeColor: "#FF33FF",
              //     strokeWeight: 3,
              //     strokeOpacity: 0.5,
              //     fillOpacity: 0.3,
              //     fillColor: "#1791fc",
              //     zIndex: 99999999,
              //   });
              //   map.add(polygon);
              // })
            }
          }
        });
      });
    },
    onWindowChange: function onWindowChange(e) {
      if (e) {
        this.markerList.forEach(function (item) {
          item.showWindow = true;
        });
      } else {
        this.markerList.forEach(function (item, index) {
          item.showWindow = false;
        });
      }
    },
    siteChange: function siteChange(data) {
      this.idType = data.type;
      this.siteId = data.id;
    },
    getAttendanceUserLast: function getAttendanceUserLast(st) {
      var _this3 = this;

      queryAttendanceUserLast({
        st: st
      }).then(function (res) {
        if (res.success) {
          _this3.peopleList = res.result;
        }
      });
    },
    resetWidth: function resetWidth() {
      this.borderWidth = document.documentElement.clientWidth * 0.25;
      this.borderHeight = document.documentElement.clientHeight * 0.275;
      this.borderWidth2 = document.documentElement.clientWidth * 0.227;
      this.borderHeight2 = document.documentElement.clientHeight * 0.275;
      this.mapBorderWidth = document.documentElement.clientWidth * 0.46;
      this.mapBorderHeight = document.documentElement.clientHeight * 0.571;
      this.waterWidth = document.documentElement.clientWidth * 0.24 + 'px';
      this.waterHeight = document.documentElement.clientHeight * 0.25 + 'px';
      this.maintenanceWidth = document.documentElement.clientWidth * 0.24 + 'px';
      this.maintenanceHeight = document.documentElement.clientHeight * 0.25 + 'px';
      this.workWidth = document.documentElement.clientWidth * 0.22 + 'px';
      this.workHeight = document.documentElement.clientHeight * 0.21 + 'px';
      this.inspectionWidth = document.documentElement.clientWidth * 0.22 + 'px';
      this.inspectionHeight = document.documentElement.clientHeight * 0.21 + 'px';
      this.medicineWidth = document.documentElement.clientWidth * 0.22 + 'px';
      this.medicineHeight = document.documentElement.clientHeight * 0.3 + 'px';
      this.warningWidth = document.documentElement.clientWidth * 0.24 + 'px';
      this.warningHeight = document.documentElement.clientHeight * 0.28 + 'px';
      this.analysisWidth = document.documentElement.clientWidth * 0.22 + 'px';
      this.analysisHeight = document.documentElement.clientHeight * 0.21 + 'px';
    },
    initData: function initData() {
      var _this4 = this;

      this.getAttendanceUserLast('52');
      this.getSite('52');
      this.$nextTick(function () {
        setTimeout(function () {
          _this4.drawBounds();
        }, 500);
      });
    },
    getWasteShape: function getWasteShape(siteName, icon, item, index) {
      var onlineStyle = '';
      var bgColor = 'ccc';

      if (item.sysUser) {
        bgColor = 'green';
        return "<div style='position: relative;'>\n              <div onclick=\"openBox(".concat(index, ")\" style='position: absolute;bottom:0;left:calc(50% - 15px);overflow:hidden;box-shadow: 0 3px 6px #000;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background-color: ").concat(bgColor, ";text-align: center;color: #000;line-height: 30px;cursor: pointer;'>\n                <div style='width:8px;height:8px;position:absolute;bottom:-3px;left:11px;transform: rotate(45deg);margin-top: -5px;box-shadow: 0 3px 6px #000;background:").concat(bgColor, "'></div>\n                <div title='").concat(siteName, "' style='position:absolute;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background-color:").concat(bgColor, ";text-align: center;color:#000;line-height: 30px;cursor: pointer;'>\n                <div class='iconfont ").concat(icon, "' style='font-size:15px;color:#fff;text-align: center;line-height: 30px;cursor: pointer;'></div>\n                ").concat(onlineStyle, "\n              </div>\n                <div style=\"background:#0a0b58;border-radius: 10px;padding: 0 10px;padding-bottom: 15px;\"></div>\n              </div>\n              <div class=\"windows-infos paddingTops window").concat(index, "\">\n                <div class=\"closeIcon\" onclick=\"closeBox(").concat(index, ")\" >X</div>\n                <div class=\"arrow-box\"></div>\n                <div class=\"site-infos-content\">\n                  <div style=\"display: flex;flex:4;overflow: hidden;\">\n                    <div class=\"site-name\"\n                         style=\"padding-left:10px;cursor: pointer;font-size: 16px;max-width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;\"\n                         title=\"").concat(siteName, "\">\n                      ").concat(siteName, "\n                    </div>\n                  </div>\n                </div>\n                <div style=\"margin-top: 50px;display: flex;justify-content: space-around;align-items: flex-start\">\n                  <img src=\"").concat(this.getImageView(item.sysUser.avatar), "\" width=\"100px\" height=\"120px\" />\n                  <div class=\"content-index\">\n                    <div style=\"margin-bottom: 5px\">").concat(item.userId_userName, "</div>\n                    <span style=\"padding: 2px 8px;background-color: #1E9FFF;color: #ffffff;border-radius: 10px\">").concat(item.category_dictText, "</span>\n                    ").concat(item.status_dictText ? "<div style=\"margin-top: 5px;\">\u5DE1\u68C0\u7ED3\u679C\uFF1A<span style=\"color:".concat(item.status_dictText == '正常' ? '#00ff80' : 'red', "\">").concat(item.status_dictText, "</span></div>") : '', "\n                    <div style=\"margin-top: 5px;display: flex;align-items: center\"><span style=\"margin-right:10px;display: flex;justify-content:center;align-items:center;width: 20px;height: 20px;font-size: 12px;color: #00ff80;border-radius: 50%;border: 1px solid #00ff80;\">\u8FDB</span>").concat(item.stime, "</div>\n                    ").concat(item.etime ? "<div style=\"display: flex;align-items: center\"><span style=\"margin-right:10px;display: flex;justify-content:center;align-items:center;width: 20px;height: 20px;font-size: 12px;color: red;border-radius: 50%;border: 1px solid red;\">\u51FA</span>".concat(item.etime, "</div>") : '', "\n                  </div>\n                </div>\n            </div>\n          </div>");
      } else {
        bgColor = '#ccc';
        return "<div style='position: relative;'>\n              <div  style='position: absolute;bottom:0;left:calc(50% - 15px);overflow:hidden;box-shadow: 0 3px 6px #000;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background-color: ".concat(bgColor, ";text-align: center;color: #000;line-height: 30px;cursor: pointer;'>\n                <div style='width:8px;height:8px;position:absolute;bottom:-3px;left:11px;transform: rotate(45deg);margin-top: -5px;box-shadow: 0 3px 6px #000;background:").concat(bgColor, "'></div>\n                <div title='").concat(siteName, "' style='position:absolute;width: 30px;height: 30px;border-radius: 50%;font-size: 10px;background-color:").concat(bgColor, ";text-align: center;color:#000;line-height: 30px;cursor: pointer;'>\n                <div class='iconfont ").concat(icon, "' style='font-size:15px;color:#fff;text-align: center;line-height: 30px;cursor: pointer;'></div>\n                ").concat(onlineStyle, "\n              </div>\n                <div style=\"background:#0a0b58;border-radius: 10px;padding: 0 10px;padding-bottom: 15px;\"></div>\n              </div>\n          </div>");
      }
    },
    getSite: function getSite(st) {
      var that = this;
      var param = st ? {
        st: st
      } : {};
      queryAttendanceSiteLast(param).then(function (res) {
        if (res.success) {
          var arr = []; // that.onlineNum = 0

          res.result.forEach(function (item, index) {
            // if (item.onlineStatus) {
            //   that.onlineNum++
            // }
            if (item.siteModel.longitude != 'NaN') item.position = [item.siteModel.longitude, item.siteModel.latitude];else item.position = ['118.04792', '24.61334'];
            item.show = true;
            item.title = item.siteName;
            item.offset = [0, -3];

            if (item.sysUser) {
              item.zIndex = 1000000;
            } else {
              item.zIndex = 100;
            } // item.siteModel.category==1?'':item.siteModel.category = 3


            item.icon = item.siteModel.category == 1 ? 'icon-bengzhan1' : 'icon-yiliaofeishui';
            item.color = '#ccc';

            if (item.sysUser) {
              item.color = 'green';
              item.showWindow = true;
              item.nodata = false;
            } else {
              item.nodata = true;
            }

            var positions;
            if (item.longitude != 'NaN') positions = [item.longitude, item.latitude];else positions = that.center;
          });
          that.markerList = res.result;
        }
      });
    },
    // 运维分析单选
    changeRadio: function changeRadio(e) {
      this.maintenanceType = e.target.value;
    },
    // 工单分析单选
    workChangeRadio: function workChangeRadio(e) {
      this.workType = e.target.value;
    },
    //巡检分析单选
    inspectionChangeRadio: function inspectionChangeRadio(e) {
      this.inspectionType = e.target.value;
    },
    //预警分析单选
    warningChangeRadio: function warningChangeRadio(e) {
      this.warningType = e.target.value;
    },
    // 故障分析
    faultChangeRadio: function faultChangeRadio(e) {
      this.faultType = e.target.value;
    },
    getImageView: function getImageView(photo) {
      if (photo) {
        return this.url.imgerver + '/' + photo;
      } else {
        return '/img/user.f3934439.png';
      }
    }
  }
};